export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/v2/landing-pages/_next/static/media/crossIconGreyBg.bde35c9a.svg","height":24,"width":24};